import "./DatasetSelect.less"
import Images from "../../utils/Images";

type DatasetSelectProps = {
    texts: string[];
    values: string[];
    value: number;
    onChange: (a: number) => void;
    onClick: (key: string) => void;
    customKey: string;
    title: string;
    isOptionsVisible: boolean;
};

export const DatasetSelect = (props: DatasetSelectProps): React.ReactElement => {
    return <div className="dataset-select">
        <div className="dataset-select-title">{props.title}</div>
        <div className="dataset-select-btn" onClick={() => props.onClick(props.customKey)}>
            <span>{props.values[props.value]}</span>
            <img src={Images.expand}></img>
        </div>
        {props.isOptionsVisible && <div className="dataset-select-options-wrap">
            <div className="dataset-select-options">
                {props.texts.map((item, i) => <div className="dataset-select-options-label" key={i} onClick={() => props.onChange(i)}>{item}</div>)}
            </div>
            <div className="data-set-select-options-arrow"></div>
        </div>}
    </div>;
};